export default {
  view_all_contacts: 'View all my contacts',
};
